import React, { useState } from "react";
import Select from "react-select";

const FixedTermReasonsSelect = (props) => {
  const reasons = [
    { value: "prenatal", label: "Pre-Natal" },
    { value: "license", label: "Licencia" },
    { value: "other_reason", label: "Otro" }
  ];

  const [fixedTermReason] = useState(reasons);

  const handleChangeReason = inputValue => {
    props.handleChange(inputValue, "fixedTermReason");
  };

  return (
    <Select
      inputId="fixedTermReason"
      onChange={handleChangeReason}
      options={fixedTermReason}
      placeholder="Seleccione una opción"
      value={fixedTermReason.find(
        (option) => option.value === props.value?.value
      ) || null}
    />
  );
};

export default FixedTermReasonsSelect;
